module.exports = __webpack_public_path__ + "static/media/report_icon.59d1592c.svg";